import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import loading from "./components/basic/view/loading/index.js";
import { createBLog } from "../src/js/log";
import registerFilter from "../src/js/filter";
require("promise.prototype.finally").shim(); //兼容finally
registerFilter();

router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    //如果未匹配到路由
    from.name
      ? next({
          name: from.name
        })
      : next("/"); //如果上级也未匹配到路由则跳转登录页面，如果上级能匹配到则转上级路由
  } else {
    let type = "";
    switch (to.name) {
      case "homepage":
        type = "LMTrackEventLaunchPage";
        break;
      case "userInfo":
        type = "LMTrackEventInfoPage";
        break;
      case "login":
        type = "LMTrackEventLoginNumPage";
        break;
      case "password":
        type = "LMTrackEventLoginPassPage";
        break;
      case "class":
        type = "LMTrackEventClassPage";
        break;
      case "playback":
        type = "LMTrackEventPlayBackPage";
        break;
      case "video":
        type = "LMTrackEventLivingPage";
        break;
      case "gameMenu":
        type = "LMTrackEventGamePage";
        break;
      case "course":
        type = "LMTrackEventLessonPage";
        break;
    }
    if (type) {
      createBLog({ id: type });
    }
    next(); //如果匹配到正确跳转
  }
});
Vue.config.productionTip = false;
Vue.use(loading);
/* eslint-disable no-new */
let root = new Vue({
  el: "#app",
  router,
  components: {
    App
  },
  store,
  template: "<App/>",
  data: {
    eventHub: new Vue()
  },
  created() {}
});



// WEBPACK FOOTER //
// ./src/main.js